import { render } from "./faqList.vue?vue&type=template&id=16435c86&scoped=true&ts=true"
import script from "./faqList.vue?vue&type=script&lang=ts&config=true"
export * from "./faqList.vue?vue&type=script&lang=ts&config=true"

import "./faqList.vue?vue&type=style&index=0&id=16435c86&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16435c86"]])

export default __exports__